import { render, staticRenderFns } from "./carrierKPIDetail.vue?vue&type=template&id=27d40144&scoped=true"
import script from "./carrierKPIDetail.vue?vue&type=script&lang=ts"
export * from "./carrierKPIDetail.vue?vue&type=script&lang=ts"
import style0 from "./carrierKPIDetail.vue?vue&type=style&index=0&id=27d40144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d40144",
  null
  
)

export default component.exports